import { render, staticRenderFns } from "./query-show-record.vue?vue&type=template&id=1f74b773&scoped=true&"
import script from "./query-show-record.vue?vue&type=script&lang=js&"
export * from "./query-show-record.vue?vue&type=script&lang=js&"
import style0 from "./query-show-record.vue?vue&type=style&index=0&id=1f74b773&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f74b773",
  null
  
)

export default component.exports